module.exports = __webpack_public_path__ + "common/images/separatorSmall.png";


//////////////////
// WEBPACK FOOTER
// ./Common/images/separatorSmall.png
// module id = 41
// module chunks = 6